import { render, staticRenderFns } from "./ProductGroupEditButton.vue?vue&type=template&id=aa110a8a&scoped=true&"
import script from "./ProductGroupEditButton.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupEditButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupEditButton.vue?vue&type=style&index=0&id=aa110a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa110a8a",
  null
  
)

export default component.exports